import { Icon, IconsEnum, toIconsEnum } from 'components/Icons';
import { memo, useMemo } from 'react';

import { DirettissimeCardBody } from './components/direttissimeCardBody';
import { DirettissimeCardHeader } from './components/direttissimeCardHeader';
import { KeyManagerSport } from 'features/sport';
import styles from './DirettissimeCard.module.scss';
import { useAvvenimento } from 'features/sport/hooks';
import { useRouter } from 'next/router';

export type DirettissimeCardProps = {
  direttissimaKey: string;
  esitoKey: string;
  isEnabledPromo?: boolean;
};

export const DirettissimeCard = memo(function DirettissimeCard({
  esitoKey,
  isEnabledPromo,
  direttissimaKey,
}: DirettissimeCardProps) {
  const { push } = useRouter();
  const key = useMemo(() => new KeyManagerSport(direttissimaKey), [direttissimaKey]);

  const avvenimento = useAvvenimento(key.avvenimentoKey);
  const esitiDirettissime = [esitoKey];

  const disciplina = `DISCIPLINA_${avvenimento?.idDisciplina}`;

  if (avvenimento) {
    return (
      <div className={styles.container}>
        <DirettissimeCardHeader
          disciplinaIcon={toIconsEnum(disciplina)}
          manifestazioneLabel={avvenimento.descrizione}
          manifestazioneLabelTrKey={avvenimento.descrizioneTrKey}
        >
          {isEnabledPromo && (
            <button className={`${styles.icon} ${styles.cursor}`} onClick={() => push(`/promo`)}>
              <Icon className={styles.icon} iconId={IconsEnum.BONUS} color="var(--color-primary)" />
            </button>
          )}
        </DirettissimeCardHeader>
        <DirettissimeCardBody esitiDirettissime={esitiDirettissime} />
      </div>
    );
  }
  return null;
});
